import type { RootState } from '../types';

import React from 'react';
import { useSelector } from 'react-redux';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';

import * as Sentry from '@sentry/react';
import { NuqsAdapter } from 'nuqs/adapters/react-router';

import { DefaultLayout, Spinner } from '../components';
import { RootBoundary, routes } from '../router';
import { useFetchSingleFlexSupplierByUserQuery, userSelector } from '../store';
import { hasPermission } from '../utils';

export const App = () => {
  const user = useSelector(userSelector);
  const roles = useSelector((state: RootState) => state.user?.roles);
  const { data } = useFetchSingleFlexSupplierByUserQuery({ userId: user.id! });
  const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

  const router = sentryCreateBrowserRouter(
    createRoutesFromElements(
      <React.Fragment>
        <Route path="/" element={<DefaultLayout />}>
          {routes
            .filter((route) =>
              route.can === 'ViewUpload'
                ? hasPermission(roles ?? [], route.can) && (data?.canUploadOfferFile || data?.canUploadProductionPlan)
                : hasPermission(roles ?? [], route.can)
            )
            .map((route) => {
              return <Route key={route.path} path={route.path} lazy={route.component} index={route.index} errorElement={<RootBoundary />} />;
            })}
        </Route>
        <Route path="*" element={<div>Not found</div>} />
      </React.Fragment>
    )
  );

  return (
    <NuqsAdapter>
      <RouterProvider router={router} fallbackElement={<Spinner />} />
    </NuqsAdapter>
  );
};

export default Sentry.withProfiler(App);
